<svelte:options customElement={{tag: 'ia-personsservedlist'}}/>

<script>
    import {CommonStyles, MainPreloader, userSecurity} from "@intellectability/platform-common/sv";
    import {configCheck} from "@intellectability/platform-common/utils";
    import {fade} from "svelte/transition";

    import {PersonsServedList} from "../../Pages/index.js";

    let styleLoading = $state(true);
    let getConfigValue = configCheck(userSecurity.applicationConfig);

    let env_type = $derived(getConfigValue("env_type") || "dev");
</script>

<main class="mb-4">
    <CommonStyles
            env={env_type}
            local_styles_path={import.meta.env.BASE_URL}
            onerror={() => styleLoading = false}
            onload={() => styleLoading = false}
    />
    {#if styleLoading}
        <MainPreloader></MainPreloader>
    {:else}
        <div transition:fade={{duration: 250}}>
            <PersonsServedList></PersonsServedList>
        </div>
    {/if}
</main>